function copyMessage(element) {
  let range
  if (window.getSelection) {
    range = document.createRange()
    range.selectNodeContents(element)
    window.getSelection().removeAllRanges()
    window.getSelection().addRange(range)
  }
  document.execCommand('copy')
}

export default copyMessage
